/**
 * Search Form for Saga Search
 */
import  {FormContainer, RemoteDropdown, SearchForm, resultsPerPage, clearSearchValues} from './SearchForm';
import React from 'react';
import {Field, reduxForm} from 'redux-form'
import FileUtils from '../utils/FileUtils'
import { connect } from 'react-redux'
import ISpan from "../i18n/ISpan";
import defaults from "../utils/defaullts";


class SagaSearchForm extends SearchForm {

    render(){
        const {
            handleSubmit, pristine, reset, submitting
        } = this.props;

        return <FormContainer>
            <div>
                <form data-bind="submit:performSearch" onSubmit={handleSubmit}>
                    <label htmlFor="textText"><ISpan localisationId="common.labels.text" defaultValue="Text"/></label>
                    <Field name="text" id="textText" component="input" type="text" />

                    {/*<input data-bind="value:text" type="text" name="" id="textText">*/}
                        <label><ISpan localisationId="common.labels.artist" defaultValue="Artist"/></label>

                        {/*<select data-bind="value: artistName, options:artistNames, optionsText: 'optionName', optionsValue: 'optionValue',event: {change: performSearch}"></select>*/}
                    <RemoteDropdown name="artistName" endPoint={FileUtils.getArtistNamesUrl()}/>

                    {/*<input type="text" data-bind="value: artistName" style="display: none"/>*/}

                        <label><ISpan localisationId="common.labels.series" defaultValue="Series"/></label>
                        {/*<select data-bind="value: selectedSeries, options:series, optionsText: 'optionName', optionsValue: 'optionValue',event: {change: performSearch}"></select>*/}
                    <RemoteDropdown name="selectedSeries" endPoint={FileUtils.getSagaSeriesUrl()}/>


                    <div>
                            <label><ISpan localisationId="common.labels.time_period" defaultValue="Time Period"/></label>
                            <div className="row">
                                <ISpan localisationId="common.labels.from_year" defaultValue="From : "/>{' '}
                                {/*<input type="number" min="0"  name="" class="year-field" data-bind="value:startYear">*/}
                                <Field name="startYear" component="input" type="number" min={0} step={1} size={4} className="year-field"/>
                                {' '}<ISpan localisationId="common.labels.to_year" defaultValue="To : "/>{' '}
                                    {/*<input type="number" min="0" name="" className="year-field" data-bind="value:endYear">*/}
                                <Field name="endYear" component="input" type="number" min={0} step={1} size={4} className="year-field"/>
                            </div>
                        </div>




                    <label><ISpan localisationId="common.labels.results_per_page" defaultValue="Results Per Page"/></label>
                        {/*<select data-bind="value: resultsPerPage, options:paginationOptions, optionsText: 'optionName', optionsValue: 'optionValue', event: {change: performSearch}"></select>*/}
                    {resultsPerPage()}
                        <br/>
                        <button type="submit" data-bind="click: performSearch">
                            <ISpan localisationId="common.buttons.search" defaultValue="Search"/></button>{' '}
                        <button data-bind="click: clearSearch" disabled={pristine || submitting} onClick={() => {
                            reset();
                            this.props.clearSearchValues();
                        }}><ISpan localisationId="common.buttons.clear" defaultValue="Clear"/></button>

                </form>

            </div>
        </FormContainer>
    }

}

SagaSearchForm = reduxForm({
    form: 'sagaSearchForm' // a unique identifier for this form
})(SagaSearchForm);

export default SagaSearchForm = connect((state) => {
        return {
            initialValues: {
                searchType: 'saga',
                count: defaults.search.count
            }
        }
    }, (dispatch) => {
        return {
            clearSearchValues: () => dispatch(clearSearchValues())
        }
    }
)(SagaSearchForm);



// WEBPACK FOOTER //
// ./src/components/SagaSearchForm.js